import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Lens as CircleIcon, Settings as SettingsIcon } from '@mui/icons-material';

import {
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  TextField,
  ListItem,
  ListItemIcon,
} from '@mui/material';

import Tile from '../../../../common/components/Tile/Tile';

import PermissionsCheck from '../../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../../common/constants/PermissionsEnum';

class InstrumentStateTypes extends PureComponent {
  render() {
    return (
      <div className="alerts-severity-type" data-qa="qa-alerts-severity-type-table">
        <Tile
          title="Instrument state types"
          TitleIcon={SettingsIcon}
          helpTag="instrument_state_types"
        >
          {!this.props.data.length ? (
            <p>No data to show</p>
          ) : (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Instrument state</TableCell>
                  <TableCell>Alert severity name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.props.data.map((el) => (
                  <TableRow key={el.InstrumentStateTypeEntityId}>
                    <TableCell>{el.StateType}</TableCell>
                    <TableCell style={{ width: '60%' }}>
                      <PermissionsCheck permission={PermissionsEnum.EDIT_ALERT_CONFIGURATION}>
                        <TextField
                          variant="standard"
                          select={true}
                          value={el.AlertSeverityTypeEntity.Level}
                          onChange={(e) => {
                            this.props.onChange(el.InstrumentStateTypeEntityId, e.target.value);
                          }}
                          data-qa="qa-alert-severity-dropdown"
                          style={{ width: '100%' }}
                        >
                          {this.props.alerts.map((alert) =>
                            alert.MappedToInstrumentState === true ? (
                              <ListItem
                                button
                                key={alert.AlertSeverityTypeEntityId}
                                value={alert.Level}
                              >
                                <ListItemIcon>
                                  <CircleIcon
                                    style={{
                                      width: '.75rem',
                                      height: '.75rem',
                                      top: '0',
                                      fill: alert.Color,
                                      display: 'inline-block',
                                    }}
                                  />
                                </ListItemIcon>

                                {alert.Name}
                              </ListItem>
                            ) : null
                          )}
                        </TextField>
                      </PermissionsCheck>
                      <PermissionsCheck
                        permission={PermissionsEnum.EDIT_ALERT_CONFIGURATION}
                        hasPermission={false}
                      >
                        <span>{el.AlertSeverityTypeEntity.Name}</span>
                      </PermissionsCheck>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Tile>
      </div>
    );
  }
}

InstrumentStateTypes.propTypes = {
  data: PropTypes.array,
  alerts: PropTypes.array,
  onChange: PropTypes.func,
};

export default InstrumentStateTypes;
